module.exports = __webpack_public_path__ + "img/teaser_005.df4acdca.webp";